import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';
import { RenderLocalesWithComponents } from '@/_shared/components';
import { Routes } from '@/_shared/constants/routes';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

export const EmptyStateNoCompletedEmployees: FC = () => {
  const t = useTranslations('departments.tabs.assessment.noCompletedEmployees');
  const navigate = useNavigate();
  const { genericResponsiveValue } = useResponsiveStyle();

  const goToPeople = useCallback(() => {
    navigate(Routes.People);
  }, [navigate]);

  return (
    <Box
      maxWidth={genericResponsiveValue({
        defaultValue: '80%',
        breakPoints: { mobile: '100%' },
      })}
      mx='auto'
      textAlign='center'
      mt='xl'
    >
      <Typography variant='h2' mb='xs'>
        {t('title')}
      </Typography>
      <Typography variant='p3/light' mb='xs'>
        {t('description')}
      </Typography>
      <Typography variant='p3/light'>
        <RenderLocalesWithComponents
          text={t('alert.label', {
            downloadFile: '!{CTA}!',
          })}
          placeholders={{
            '!{CTA}!': (
              <Typography
                as='span'
                data-testid='go-to-public-docs'
                color='primary'
                fontWeight='500'
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={goToPeople}
              >
                {t('alert.ctaLabel')}
              </Typography>
            ),
          }}
        />
      </Typography>
    </Box>
  );
};
